<template>
  <BasePie :name='name' :getDataAction='GetStockByIsCharges' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BasePie>
</template>



<script>
import {
  GetStockByIsCharges
} from '@/api'
import BasePie from './../basePie.vue'

export default ({
  components: {
    BasePie
  },
  data () {
    return {
      GetStockByIsCharges: GetStockByIsCharges
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },
  mounted () {
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
})
</script>
<style scoped lang="scss">
</style>